import {
  ClaimsFiltersForm,
  useClaimTypeMapping,
  useFormattedDateRange
} from 'models/claims'
import { useTranslation } from 'react-i18next'

type ClaimsFilterDisplayProps = {
  filters: ClaimsFiltersForm
}
export const ClaimsFilterDisplay = ({ filters }: ClaimsFilterDisplayProps) => {
  const { t } = useTranslation('claimsSearch')
  const claimTypes = useClaimTypeMapping()
  const formattedDateRange = useFormattedDateRange(filters.dateRange, filters.customDateRange)

  return (
    <>
      <dl className="ds-u-text-align--left my-u-my--4 my-u-md-my--8">
        <dt>{t('currentSearch.claimTypeLabel')}</dt>
        <dd className="ds-u-margin--0 ds-u-font-weight--semibold">
          {(filters.claimType ? claimTypes[filters.claimType] : t('filterClaimTypeAll'))}
        </dd>
      </dl>
      <dl className="ds-u-text-align--left my-u-my--4 my-u-md-my--8">
        <dt>{t('currentSearch.dateRangeLabel')}</dt>
        <dd className="ds-u-margin--0 ds-u-font-weight--semibold">
          {formattedDateRange}
        </dd>
      </dl>
    </>
  )
}
